import { createAxiosClient } from '../axiosDefaults';
const CUSTOMER_DATA_PATH = 'marketing-direct-auction/customer-data';
export function createApi(baseURL, config) {
  let axiosConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const axiosInstance = createAxiosClient({
    baseURL,
    withCredentials: true,
    ...axiosConfig
  }, config);
  return {
    getCustomerData,
    createCustomerData
  };

  function getCustomerData(carleadHash) {
    return axiosInstance.get(CUSTOMER_DATA_PATH + "/hash/" + carleadHash + "/").then(res => res.data);
  }

  function createCustomerData(carleadHash, data) {
    return axiosInstance.post(CUSTOMER_DATA_PATH, { ...data,
      carLeadHash: carleadHash
    }).then(res => res.data);
  }
}